//customization of footer logo

import logo from 'laspezia-theme/components/layout/images/logo.png';

const LogoFooter = () => (
  <img src={logo} alt="Città della Spezia" height="82px" width="82px" />
);

export default LogoFooter;
